module.exports = __webpack_public_path__ + "img/emo_01.1cb4f698.gif";